var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownloadOrange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.47489 11.8098C2.47489 12.7566 3.2424 13.5241 4.18917 13.5241L11.8082 13.5241C12.755 13.5241 13.5225 12.7566 13.5225 11.8098L13.5225 11.0479C13.5225 10.7324 13.7783 10.4765 14.0939 10.4765C14.4095 10.4765 14.6654 10.7324 14.6654 11.0479L14.6654 11.8098C14.6654 13.3878 13.3862 14.667 11.8082 14.667L4.18917 14.667C2.61122 14.667 1.33203 13.3878 1.33203 11.8098L1.33203 11.0479C1.33203 10.7324 1.58787 10.4765 1.90346 10.4765C2.21905 10.4765 2.47489 10.7324 2.47489 11.0479L2.47489 11.8098ZM4.54702 7.59627C4.77017 7.37311 5.13198 7.37311 5.35514 7.59627L7.42727 9.66839L7.42727 1.90509C7.42727 1.5895 7.6831 1.33366 7.9987 1.33366C8.31429 1.33366 8.57012 1.5895 8.57012 1.90509L8.57013 9.66839L10.6423 7.59626C10.8654 7.37311 11.2272 7.37311 11.4504 7.59626C11.6735 7.81942 11.6735 8.18123 11.4504 8.40439L8.40276 11.452C8.1796 11.6752 7.81779 11.6752 7.59464 11.452L4.54702 8.40439C4.32386 8.18123 4.32386 7.81942 4.54702 7.59627Z",
    fill: "#D53E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadOrange);
export default __webpack_public_path__ + "static/media/icon-download-orange.137a0843240d1f108b1dc95962c09cd4.svg";
export { ForwardRef as ReactComponent };